import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=1990179d&scoped=true&"
import script from "./stepFour.vue?vue&type=script&lang=ts&"
export * from "./stepFour.vue?vue&type=script&lang=ts&"
import style0 from "./stepFour.vue?vue&type=style&index=0&id=1990179d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990179d",
  null
  
)

export default component.exports